import styled from 'styled-components';

import BulletCheckIconSVG from '../../assets/icons/bullet-check-icon.svg';
import { colors } from '../constants';

export const FeatureListItem = styled.div`
  padding: 0.375rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 28rem;
`;
FeatureListItem.displayName = 'FeatureListItem';

export const FeatureListItemBullet = styled(BulletCheckIconSVG)`
  height: 1.125rem;
  width: 1.125rem;
  min-width: 1.125rem;
  max-width: 1.125rem;
  margin-right: 0.75rem;
`;
FeatureListItemBullet.displayName = 'FeatureListItemBullet';

export const FeatureListItemText = styled.p`
  color: ${colors.TEXT_PRIMARY};
  line-height: 1.25rem;
`;
FeatureListItemText.displayName = 'FeatureListItemText';
